// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2BxC5","inputWrap":"CustomTip_inputWrap__16ldI"};